import React, { useState } from 'react';
import { DragDropContext, Draggable, Droppable } from 'react-beautiful-dnd';
import { IconButton } from '@material-ui/core';
import { AddCircleOutlineOutlined } from '@material-ui/icons';
import { useFormContext } from '../FormContext';
import ConfigCard from './components/ConfigCard';
import ConfigHeader from './components/ConfigHeader';
import FormConfigEvent from './FormConfigEvent';
import { useQueryParam, StringParam } from 'use-query-params';
export const FormConfigEventList = () => {
    const { formState, addEvent, updateEvent, moveEvent, deleteEvent } = useFormContext();
    // handle selecting event transition button
    const [selectedEventTransition] = useQueryParam('event-transition', StringParam);
    const [expandedIndex, setExpandedIndex] = useState();
    const stateNode = formState.selectedStateNode;
    const { events = [] } = stateNode;
    return (React.createElement(ConfigCard, null,
        React.createElement(ConfigHeader, { end: React.createElement(IconButton, { size: 'small', onClick: () => addEvent() },
                React.createElement(AddCircleOutlineOutlined, null)) }, "Event Transitions"),
        React.createElement(DragDropContext, { onDragEnd: result => {
                const { source, destination } = result;
                // dropped outside the list
                if (!destination) {
                    return;
                }
                moveEvent(source.index, destination.index);
                if (expandedIndex === source.index) {
                    setExpandedIndex(destination.index);
                }
            } },
            React.createElement(Droppable, { droppableId: 'events' }, provided => (React.createElement("div", { className: 'event-list', ref: provided.innerRef },
                events.map((event, index) => (React.createElement(Draggable, { key: index, index: index, draggableId: `draggable-${index}` }, (provided, snapshot) => (React.createElement(FormConfigEvent, Object.assign({ ref: provided.innerRef, className: snapshot.isDragging ? 'dragging' : '', expanded: expandedIndex === index ||
                        (typeof selectedEventTransition === 'string' &&
                            event.name === selectedEventTransition) }, provided.draggableProps, { dragHandleProps: provided.dragHandleProps, event: event, onDelete: () => deleteEvent(index), onChange: event => updateEvent(index, event), onExpand: (_, isExpanded) => setExpandedIndex(isExpanded ? index : undefined) })))))),
                provided.placeholder))))));
};
export default FormConfigEventList;
//# sourceMappingURL=FormConfigEventList.js.map